import { FunctionComponent } from "react";
import "./PoolPageActions.scss";
import NumberFormat from "react-number-format";

type ActionCardProps = {
    icon: string;
    title: string;
    amount: number;
    suffix: string;
}

const ActionCard: FunctionComponent<ActionCardProps> = ({icon, title, amount, suffix}) => {
    return (
        <>
            <div className="action-card">
                <span className="brand-color-white action-title">{title}</span>
                <img src={icon} alt={title} width={130} height={130} />
                <NumberFormat className={"brand-color-white action-amount"} value={amount} displayType={"text"} thousandSeparator={true} suffix={` ${suffix}`} />
                <button className={"btn btn-brand action-button"}>{title}</button>
            </div>
        </>
    );
};

export default ActionCard;
